import { action, extend, register, types } from "@gadgetinc/mobx-quick-tree";
import { EnvironmentNameMSTType, type LegacyEnvironmentName } from "../../Environment";
import { contentHash } from "../../utils";
import { ShopifyBasePartnerAppConfig } from "./ShopifyBasePartnerAppConfig";

/**
 * See packages/state-trees/src/connections/ShopifyConnectionConfig.ts for documentation
 * on the different types of Shopify configurations
 */
@register
export class ShopifyLegacyPartnerAppConfig extends extend(ShopifyBasePartnerAppConfig("ShopifyAppConfig"), {
  environment: EnvironmentNameMSTType,
  customRedirectURL: types.array(types.string),
  isCli: types.optional(types.boolean, false),
}) {
  get appURL() {
    return this.customRedirectURL.slice().sort()[0];
  }
  get contentHash() {
    return contentHash([
      this.apiKey,
      this.apiSecretKey,
      this.environment,
      ...this.customRedirectURL.slice().sort(),
      this.isCli,
      this.appId,
      this.appName,
    ]);
  }
  @action
  setEnvironment(value: LegacyEnvironmentName) {
    this.environment = value;
  }
  @action
  setCustomRedirectUrl(value?: string) {
    this.customRedirectURL.replace(value ? [value] : []);
  }
  @action
  setIsCli(value: boolean) {
    this.isCli = value;
  }
  @action
  setAppURL(value?: string) {
    this.setCustomRedirectUrl(value);
  }
}
